import React, { useState, useRef, useEffect, useMemo } from "react";
import { useLocation, Link, Routes, Route, useParams, useNavigate, useSearchParams } from "react-router-dom";
import './FilesView.css';
import FilesViewContent from "./FilesViewContent";
import FilesViewModal from "./FilesViewModal";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import { AiOutlineSortAscending } from 'react-icons/ai'
import "react-toastify/dist/ReactToastify.css";
import withReactContent from "sweetalert2-react-content";
import { useFilesViewStore, useAppStore } from "../../stores";
import { handleXhrError } from "../../utils";
import ContentLoader from "react-content-loader";
//toast
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

//sweetalert
const MySwal = withReactContent(Swal);

const FilesView = (props) => {
  const [open, setOpen] = useState(false);
  const modalRef = useRef({});
  // const handleFile = (file) => {
  //   console.log(modalRef);
  //   modalRef.current = file
  //   setOpen(true);
  // }
  const { fId, subId, secId, facId, batch } = useParams();
  const [search] = useSearchParams();
  const category = search.get("category");
  const exam = search.get("exam");
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state || {};
  const addAll = useFilesViewStore((state) => state.addAll);
  const files = useFilesViewStore((state) => state.files);
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);
  const filesLoading = useFilesViewStore((state) => state.loading);
  const subject = useFilesViewStore((state) => state.subjects)[0];
  const [sortByName, setSortByName] = useState(false)

  console.log(files)
  const sortedFiles = (files.length>0 ? [...files]:[]).sort((a,b)=>(sortByName && a.name > b.name))
  useEffect(() => {
    if (fId && !filesLoading) {
      const file = files.filter(f => f._id == fId)[0];
      if (file) {
        modalRef.current = file;
        setOpen(true);
      }
      else {
        navigate(`/files/${subId}/${secId}/${batch}/${facId}?category=${category}&exam=${exam}`, { state: { error: "No such file found" } });
      }
    }
    else {
      // navigate(`/files/${subId}/${secId}/${batch}/${facId}`);
    }
  }, [fId, filesLoading])
  useEffect(() => {
    if (filesLoading) {
      showLoading();
    }
    else {
      hideLoading();
    }
  }, [filesLoading])
  useEffect(() => {
    window.$.ajax({
      type: "get",
      url: `/api/file/${subId}/${secId}?faculty=${facId}&category=${category}&batch=${batch}&exam=${exam}`,
      xhrFields: {
        withCredentials: true,
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        addAll(response);
      },
      statusCode: {

        404: function () {

          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }, [])
  const handleOnClose = () => {
    setOpen(false);
    navigate(`/files/${subId}/${secId}/${batch}/${facId}?category=${category}&exam=${exam}`);
  }
  if (filesLoading) {
    return <></>
  }
  return (
    <>

      <div className="p-2">
        <h4 >{subject ? subject.name : ""}</h4>
        <div className="row">
          <AiOutlineSortAscending style={{
            color: sortByName ? "red": "black",
            "width": "2rem",
            "background": "#d5e2ef",
            "borderRadius": "8px",
            "height": "1.78rem",
            "padding": "5px",
            "border": "solid 1px #879baf",
            "margin-left": "0.7rem",
            "boxShadow": "rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px"
          }} onClick={() => setSortByName(!sortByName)} />
          <h6>{locationState.error}</h6>
        </div>
        <div className="row p-3">
          {
            sortedFiles.map(file => <FilesViewContent  {...file} category={category} exam={exam} />)
          }
        </div>
      </div>
      <FilesViewModal ref={modalRef} open={open} onClose={handleOnClose} />
    </>
  );
};

export default FilesView;
